module.exports = __webpack_public_path__ + "img/alarm.5627ca14.svg";